import { confirmDialog, Decorators, Fluent, notifyError, notifySuccess, resolveUrl, serviceCall, ServiceResponse, localText } from "@serenity-is/corelib";
import { ExpiringSessionResponse } from "@/ServerTypes/Common";

@Decorators.registerClass('hsWartung.Common.ExpiringSessionWarner')
export class ExpiringSessionWarner {
    /**
     * Zeit in Minuten, bevor der Session-Ablauf-Dialog kommt
     */
    private static readonly _MIN_BEFORE_POPUP: number = 30;

    private static _Instance: ExpiringSessionWarner;

    public static run(): void {
        if (!ExpiringSessionWarner._Instance)
            ExpiringSessionWarner._Instance = new ExpiringSessionWarner();
    }

    private constructor() {
        var _this = this;
        window.onload = () => _this.checkForExpiry();
    }

    private remainingTime(session: ExpiringSessionResponse): number {
        var diff: number = new Date(session.SessionEnd).getTime() - Date.now();
        if (diff < 0) diff = 0;
        return diff;
    }

    private remainingTimeString(session: ExpiringSessionResponse): string {
        var diff: number = this.remainingTime(session);
        var span: Date = new Date(diff);
        var minutes = span.getMinutes();
        var seconds = span.getSeconds();
        return (minutes < 10 ? '0' : '') + minutes.toString() + ':' + (seconds < 10 ? '0' : '') + seconds.toString();
    }

    private aboutToExpireDialog(session: ExpiringSessionResponse): void {
        var _this = this;

        var interval = function () {
            var intervalid: number = -1;
            return {
                onOpen: () => {
                    intervalid = setInterval(() => {
                        if (_this.remainingTime(session) == 0)
                            Fluent.findFirst('.expiring-session-dialog .ui-dialog-titlebar-close').click();

                        Fluent.findFirst('.expiring-session-dialog .message').text(localText('Controls.Session.AboutToExpire').replace('{0}', _this.remainingTimeString(session)));
                    }, 1000);
                },
                onClose: () => {
                    if (intervalid < 0) return;
                    clearInterval(intervalid);
                    intervalid = -1;
                }
            }
        }();

        confirmDialog(localText('Controls.Session.AboutToExpire').replace('{0}', this.remainingTimeString(session)), () => {
            serviceCall({
                url: '/Session/Refresh',
                method: 'POST'
            }).then(() => {
                notifySuccess(localText('Controls.Session.Extension.Success'));
                this.checkForExpiry();
            },
                () => notifyError(localText('Controls.Session.Extension.Error'))
            );
            interval.onClose();
        }, {
            dialogClass: 'expiring-session-dialog s-MessageDialog s-ConfirmDialog',
            title: 'Session',
            onOpen: interval.onOpen,
            onClose: interval.onClose,
            onNo: () => {
                window.location.href = resolveUrl('~/Account/Signout');
            },
            onCancel: () => {
                window.location.href = resolveUrl('~/Account/Signout');
            },
        });
    }

    private checkForExpiry() {
        var _this = this;

        //Session-Ablauf-Warnung
        serviceCall({
            url: '/Session/Info',
            method: 'GET'
        }).then((session: ExpiringSessionResponse) => {
            //Wenn keine Session verfuegbar, z. B. wenn noch nicht eingeloggt
            if (!session.IsValid) return;

            var dialogpopup: number = new Date(session.SessionEnd).getTime() - (ExpiringSessionWarner._MIN_BEFORE_POPUP * 60000);
            var now: number = Date.now();

            if (now > dialogpopup) {
                _this.aboutToExpireDialog(session);
            } else {
                setTimeout(_this.aboutToExpireDialog, dialogpopup - now, session);
            }
        });
    }
}